import React, { FC } from "react";

type Props = Record<string, never>;
const BaseTerms: FC<Props> = () => {
  return (
    <>
      <section>
        <h1>
          <span style={{ display: "inline-block" }}>アニメファンド</span>
          <span style={{ display: "inline-block" }}>利用規約</span>
        </h1>
      </section>
      <section>
        <p>
          アニメファンド株式会社（以下「当社」といいます。）が提供するクラウドファンディングサービス（以下「本サービス」といいます。）についての利用規約をここに定めます。当サイトを利用するすべての利用者（以下「ユーザー」といいます。）は本規約が本サービスを利用するための契約の内容になることに合意するものとします。
        </p>
      </section>
      <section>
        <h4>第１条（定義）</h4>
        <p>本規約において用いる用語の定義は次の通りとします。</p>
        <ul>
          {[
            {name: "会員", description: "本規約を承認の上、当社が定める方法により、本サービス利用のために入会を申し込み、当社が承認した者"},
            {name: "ユーザー", description: "本サービスを利用するすべてのユーザー"},
            {name: "プロジェクト", description: "本サービス上で掲載される企画、商品等"},
            {name: "プロジェクトオーナー", description: "プロジェクトの企画、管理、運営等の実行者"},
            {name: "応援者", description: "プロジェクトを応援するユーザー"},
            {name: "応援", description: "応援者が、プロジェクトに対する共感のもとプロジェクトオーナーに対して一定の金員を払う行為"},
            {name: "リターン", description: "プロジェクトの応援に対してプロジェクトオーナーから提供される商品またはサービス"},
            {name: "応援期間", description: "本サービス上でプロジェクト毎にプロジェクトオーナーが設定した応援を募集する期間"},
            {name: "目標金額", description: "各プロジェクトについて、プロジェクトオーナーが設定した応援総額の目標金額"},
          ].map((definition, index) => (
            <li key={index}>
              （{index+1}）「{definition.name}」
              <br />
              {definition.description}
            </li>
          ))}
        </ul>
      </section>
      <section>
        <h4>第２条（契約当事者）</h4>
        <p>
          <strong>１項</strong>
          プロジェクトが成立した場合、プロジェクトオーナーと応援者との間において応援契約が成立します。プラットフォームの提供者であるアニメファンドは応援契約の当事者ではありません。
        </p>
        <p>
          <strong>２項</strong>
          アニメファンドは、プロジェクトオーナーによるリターンの不履行に備えて保険に加入することがあります。アニメファンドの保険加入は、あくまで顧客サービスの一環であり、これによりアニメファンドがリターン履行について何らかの法的責任を負うことはありません。
        </p>
        <p>
          <strong>３項</strong>
          アニメファンドは、本条に基づきアニメファンドが行った行為により会員に生じた損害について一切の責任を負いません。
        </p>
      </section>
      <section>
        <h4>第３条（プロジェクトの類型と成立）</h4>
        <p>
          <strong>１項</strong>購入型プロジェクト
        </p>
        <p>
          購入型プロジェクトは、プロジェクトが成立した際にプロジェクトオーナーと応援者との間に成立する応援契約が売買契約をはじめとする有償契約であるプロジェクトをいいます。プロジェクトオーナーは、応援者に応援契約の対価であるリターンを提供します。
        </p>
        <p>
          <strong>２項</strong>プロジェクトは、成立条件の違いに応じて「All or Nothing方式」と「All in方式」とがあります。
        </p>
        <ul>
          <li>
            （１）All or Nothing方式
            <br />
            募集期間満了時において、プロジェクトに対する応援が目標金額に到達した場合にプロジェクトが成立し、集まった応援額がプロジェクトオーナーに支払われます。募集期間内に応援額が目標金額を達成できなかった場合にはプロジェクトは不成立となり、返金を行います。
          </li>
          <li>
            （２）All in方式
            <br />
            募集期間内において、プロジェクトに対する応援が１円に到達した場合にプロジェクトが成立し、集まった応援額が目標金額に到達したか否かにかかわらずプロジェクトオーナーに支払われます。
          </li>
        </ul>
      </section>
      <section>
        <h4>第４条（プロジェクトオーナーに発生する手数料）</h4>
        <p>
          プロジェクトが成立した場合、プロジェクトオーナーは、アニメファンドに対して、手数料及び決済手数料として応援総額の一定割合の金額を支払う義務を負うものとします。各サービスにおける手数料及び決済手数料の割合及びその支払時期方法については、別途プロジェクト契約書において定めるものとします。
        </p>
      </section>
      <section>
        <h4>第５条（リターンの提供）</h4>
        <p>
          <strong>１項</strong>
          プロジェクトオーナーは、あらかじめ応援者が応援する金額に応じて、その額の範囲内のリターンを設定しなければなりません。
        </p>
        <p>
          <strong>２項</strong>
          プロジェクトオーナーはあらかじめ設定したリターンを応援者に対して提供します。
        </p>
        <p>
          <strong>３項</strong>
          プロジェクトオーナーは、各プロジェクトのリターン毎の発送（履行）を行うものとします。諸般の事情により遅延・遅配が生じる場合は、プロジェクトオーナー自らが該当する応援者へ連絡を行うものとし、アニメファンドはかかる遅延、遅配について一切責任を負わないものとします。
        </p>
        <p>
          <strong>４項</strong>
          プロジェクトオーナーは、リターンについての問い合わせ等があった場合には、当該問い合わせに対し、自らの責任で誠実に回答するものとします。
        </p>
        <p>
          <strong>５項</strong>
          リターンの変更や中止はできません。プロジェクトオーナーは、やむを得ない事情によりリターンの内容の変更等が必要である場合には、自己の責任で応援者の個別の同意を得るものとし、同意を得られた範囲内においてのみリターンの変更を行うものとします。
        </p>
        <p>
          <strong>６項</strong>
          プロジェクトオーナーは、リターンの提供のために応援者の個人情報（住所、電話番号、メールアドレス等）が必要となる場合、アニメファンドの定める方法により当該情報を取得するものとします。この場合、応援者の個人情報はリターンの履行に必要な範囲でのみ利用できます。プロジェクトオーナーが、リターンの履行以外の目的で応援者の個人情報を利用するためには、自らの責任において応援者から個別の同意を取得しなければなりません。また、取得した個人情報の管理はプロジェクトオーナーが責任を持って行うものとし、アニメファンドは情報の漏えい等のトラブルにより生じる損害については一切責任を負いません。
        </p>
      </section>
      <section>
        <h4>第６条（プロジェクトのキャンセル）</h4>
        <p>
          <strong>１項</strong>
          本サービスに掲載が開始されたプロジェクトは、アニメファンドの承諾なく掲載を取り下げること、および、募集期間や目標金額、リターンの内容や金額を変更することはできません。ただし、やむを得ない理由でプロジェクトの継続ができないとプロジェクトオーナーが判断し、プロジェクトオーナーが速やかにアニメファンドまでその旨を通知した上、アニメファンドが承諾した場合に限り、プロジェクトの掲載を終了することができます。なお、この場合、プロジェクトオーナーは、アニメファンドが定める一定のキャンセル手数料（内容はプロジェクトお申込書にて定めます。）が発生することについてあらかじめ了承するものとします。
        </p>
        <p>
          <strong>２項</strong>
          前項の場合、プロジェクトオーナーはアニメファンドの定める方法で応援者にキャンセルの経緯を説明した上、応援者からの個々の問い合わせについて責任をもって対応することとします。
        </p>
      </section>
      <section>
        <h4>第７条（プロジェクトに関するトラブル）</h4>
        <p>
          <strong>１項</strong>
          プロジェクト活動進行中に発生する応援契約当事者間でのトラブル、返金要求、その他紛争については、応援契約の当事者であるプロジェクトオーナーと応援者との間で解決すべき問題であり、アニメファンドはこれに関して一切責任を負いません。
        </p>
        <p>
          <strong>２項</strong>
          アニメファンドは、当サービスの健全性を確保する見地から、応援契約の当事者に事実関係の確認をする場合があり、ユーザーはアニメファンドの事実確認に協力しなければなりません。
        </p>
      </section>
      <section>
        <h4>第８条（応援額の支払い）</h4>
        <p>
          <strong>１項</strong>
          プロジェクトオーナーは、アニメファンドに対して、応援者から支払われる応援額をプロジェクトオーナーに代わって受領するための代理受領権限を付与するものとします。アニメファンドが、応援契約に基づき応援者より支払われる応援額を、プロジェクトオーナーに代わって受領した時点で、応援者の応援額支払義務の履行が完了したものとします。
        </p>
        <p>
          <strong>２項</strong>
          アニメファンドは、プロジェクトが成立した場合、プロジェクトオーナーに対し、アニメファンド所定の方法にて応援者に代わって受領した応援額を支払います。この場合の振込手数料はアニメファンドが負担します。
        </p>
        <p>
          <strong>３項</strong>
          アニメファンドは、プロジェクトオーナーへの応援額の支払に際して、プロジェクトオーナーがアニメファンドに支払うべき手数料その他の一切の債務を差し引くものとします。応援額の支払いの方法についてはサービス内容に応じてプロジェクトお申込書に定めます。
        </p>
      </section>
      <section>
        <h4>第９条（利用資格について）</h4>
        <p>
          <strong>１項</strong>
          応援者としてプロジェクトを応援するには、原則として日本国内に住所を有している（住民票があることを意味します。）必要があります。アニメファンドがプロジェクトまたはリターンごとに海外に住所を有する応援者による応援を認めた場合に限り、日本国内に住所を有しないユーザーも応援者となることができます。
        </p>
        <p>
          <strong>２項</strong>
          応援者となるユーザーは、アニメファンドが必要と判断する場合、住民票の写し又はアニメファンドが必要と認める書類を提供しなければなりません。
        </p>
      </section>
      <section>
        <h4>第１０条（プロジェクトへの応援）</h4>
        <p>
          <strong>１項</strong>
          ユーザーは、アニメファンドの定める方法によりプロジェクトの応援を申し込むことができます。応援の申込みが完了した時点で、プロジェクトが成立することを条件とする応援契約が成立します。
        </p>
        <p>
          <strong>２項</strong>
          アニメファンドは、第６条１項記載の事由が認められる場合、前項の応援の申込みを拒絶することができます。
        </p>
        <p>
          <strong>３項</strong>
          ユーザーは、応援の申込みをするにあたり、対象のプロジェクト毎に本サービス上で表示される記載内容を理解のうえ同意する必要があり、応援の申込みをしたユーザーはこれに同意したものとみなします。
        </p>
        <p>
          <strong>４項</strong>
          アニメファンドは、応援契約が成立した時点で、プロジェクトページ内に当該応援者の応援状況を表示することができるものとします。ただし、応援者の応援状況について表示の義務を負うものではありません。
        </p>
      </section>
      <section>
        <h4>第１１条（応援のキャンセル）</h4>
        <p>
          <strong>１項</strong>
          応援者は、応援を表明したプロジェクトについて、その応援をキャンセルすることができません。
        </p>
        <p>
          <strong>２項</strong>
          アニメファンドにおいて次の事実を認める場合には、その応援はキャンセルされます。
        </p>
        <ul>
          <li>
            （１）プロジェクトの募集期間の終了から３０日を越えてもアニメファンド所定の方法による応援額の決済手続きが完了しない場合
          </li>
          <li>（２）応援者に対するリターンの履行が不可能若しくは著しく困難である場合</li>
        </ul>
        <p>
          <strong>３項</strong>
          プロジェクト進行不可能となった場合やリターンの履行遅延・履行不可能となった場合などいかなる理由を問わずアニメファンドは応援額を返金する義務を負いません。
        </p>
      </section>
      <section>
        <h4>第１２条（リターンの取得）</h4>
        <p>
          <strong>１項</strong>
          当該プロジェクトを応援した応援者は、アニメファンド所定の方法による応援額の決済手続きが完了することを条件として、プロジェクトオーナーに対し、各プロジェクトにおいて定められたリターンを得る権利を有するものとします。
        </p>
        <p>
          <strong>２項</strong>
          応援者は、選択したリターンの変更・キャンセル・返金要求はできません。ただし、プロジェクトオーナーと応援者との個別の合意がある場合にはその合意が優先します。
        </p>
        <p>
          <strong>３項</strong>
          リターンの履行は、プロジェクトオーナーが応援契約に基づいて履行の責任を負うものであり、アニメファンドは、リターンの履行、及びリターンの不履行による損害賠償責任を負いません。
        </p>
      </section>
      <section>
        <h4>第１３条（プロジェクトが不成立、キャンセルの場合等）</h4>
        <p>
          <strong>１項</strong>
          何らかの事由により、プロジェクトオーナーによるリターンの履行が出来ない場合、アニメファンドは審議の上、応援者への応援金の返還を行います。
          この際、応援者は所定の方法で応援金の決済手続きが完了している必要があります。
          また、応援者はアニメファンドの応援金返還手続きへの協力義務を負います。
        </p>
        <p>
          <strong>２項</strong>
          前項の場合の送金手数料は、アニメファンドが負担します。
        </p>
      </section>
      <section>
        <h4>第１４条（応援の方法、手数料）</h4>
        <p>
          <strong>１項</strong>
          応援者はアニメファンドの定める方法により応援額の支払いをします。応援額は、プロジェクトオーナーに代わりアニメファンドが受領します。応援者が、アニメファンドに対して応援額を支払った時点をもって応援者の応援額の支払は完了します。
        </p>
        <p>
          <strong>２項</strong>
          応援者が応援額を支払う際のシステム利用料は、2021年7月より完全無料とします。
        </p>
      </section>
      <section>
        <h4>第１５条（会員申込）</h4>
        <p>
          <strong>１項</strong>
          アニメファンドの会員となるには、本規約およびアニメファンドプライバシーポリシーの内容をお読みいただき、本規約を遵守することに同意のうえ、アニメファンドの提供する入力フォームにて所定の情報を提供する方法による会員登録への申込み手続きが必要です。入力に際しては、真正な情報を提供していただく必要があります。同一人が複数の会員登録をすることはできません。
        </p>
        <p>
          <strong>２項</strong>
          前項の申込に対してアニメファンドが承諾をした場合、承諾をした時点をもって会員登録手続は完了し、申込者は、この時点から会員としての地位を取得します。なお、アニメファンドは、次の場合には申込に対する承諾を行いません。
        </p>
        <ul>
          <li>
            （１）申込の際にアニメファンドに提供された情報（以下「登録情報」という。）の全部または一部につき虚偽、誤記または記載漏れがあった場合
          </li>
          <li>（２）過去に会員資格を停止された、または停止事由に該当したことが判明した場合</li>
          <li>（３）その他、アニメファンドが登録を適当でないと判断した場合</li>
        </ul>
        <p>
          <strong>３項</strong>
          アニメファンドは、前条の承諾をしない場合において、申込者にその理由を開示する義務を負いません。
        </p>
      </section>
      <section>
        <h4>第１６条（会員ＩＤおよびパスワードの管理）</h4>
        <p>
          <strong>１項</strong>
          会員は、アニメファンドが会員に付与する会員ＩＤ、パスワード等の管理および保管を行う責任を負うものとします。会員は、設定したパスワードを定期的に変更して不正利用の防止に努めなければなりません。
        </p>
        <p>
          <strong>２項</strong>
          会員は、会員ＩＤおよびパスワード等を第三者に利用させ、または譲渡もしくは担保設定その他の処分をすることはできません。
        </p>
        <p>
          <strong>３項</strong>
          会員ＩＤおよびパスワード等の管理不十分、使用上の過誤、第三者の使用等による損害の責任は会員が負うものとし、アニメファンドは一切の責任を負いません。
        </p>
        <p>
          <strong>４項</strong>
          会員は、会員ＩＤまたはパスワードが第三者に漏えいした場合、あるいは会員ＩＤまたはパスワードが第三者に使用されている疑いのある場合には、直ちにアニメファンドにその旨を連絡するとともに、アニメファンドの指示がある場合にはこれに従うにものとします。この場合、アニメファンドはその会員ＩＤやパスワード等を不正アカウントとして停止することができるものとします。
        </p>
      </section>
      <section>
        <h4>第１７条（届出事項の変更等）</h4>
        <p>
          <strong>１項</strong>
          会員は、入会申込の際にアニメファンドに提供した登録情報に変更があった場合は、遅滞なくアニメファンドに当該変更事項にかかる情報を提供するものとします。
        </p>
        <p>
          <strong>２項</strong>
          会員は、アニメファンドから本人確認書類その他会員資格に関する情報の開示を求められた場合は、これに応じなければなりません。
        </p>
      </section>
      <section>
        <h4>第１８条（退会）</h4>
        <p>
          <strong>１項</strong>
          会員は、所定の手続きによりアニメファンド会員登録を抹消（退会）することができます。
        </p>
        <p>
          <strong>２項</strong>
          会員が死亡した場合その他本人の会員資格の利用が不可能となる事由があったときは、アニメファンドは、当該会員がその時点で退会したものとみなし、会員ＩＤおよびパスワードの利用を停止します。
        </p>
      </section>
      <section>
        <h4>第１９条（会員資格の停止、抹消）</h4>
        <p>
          <strong>１項</strong>
          アニメファンドは、以下の事由がある場合、会員に何ら事前の通知または催告をすることなく、会員資格を一時停止し、または会員登録を抹消することができるものとします。
        </p>
        <ul>
          <li>（１）会員ＩＤまたはパスワードおよび本サービスを不正に使用しまたは使用させた場合</li>
          <li>（２）アニメファンドに提供された登録情報の全部または一部につき虚偽、誤記または記載漏れがあった場合</li>
          <li>
            （３）アニメファンド、他のユーザー、外部ＳＮＳ事業者その他の第三者に損害を生じさせるおそれのある目的または方法で本サービスを利用した、または利用しようとした場合
          </li>
          <li>（４）手段の如何を問わず、本サービスの運営を妨害した場合</li>
          <li>（５）支払債務（応援額を含む）を期限までに履行しなかった場合</li>
          <li>
            （６）会員に対し、差押、仮差押、仮処分、強制執行、破産、民事再生、会社更生、特別清算の申し立てがなされた場合、または、会員が自ら破産、民事再生、会社更生、特別清算の申し立てをした場合
          </li>
          <li>（７）登録したメールアドレスや電話番号が不通となり、アニメファンドからの連絡が不可能となった場合</li>
          <li>（９）会員が本規約の条項に違反した場合</li>
          <li>
            （１０）会員が各プロジェクトへの応援コメントにて著しく公序良俗に反する記載や、プロジェクトオーナーやプロジェクトの名誉を棄損する記載をしたとアニメファンドが判断した場合
          </li>
          <li>（１１）その他、会員として不適格とアニメファンドが判断した場合</li>
        </ul>
        <p>
          <strong>２項</strong>
          会員が前項の各号に該当することが判明した場合、アニメファンドは、該応援を無効とし、払い込まれた応援額はアニメファンドの定める手続きにより返金することができます。
        </p>
        <p>
          <strong>３項</strong>
          アニメファンドは、第１項各号に該当する合理的な疑いが生じた場合において、事実確認が完了するまで当該会員のサービスの利用を一時的に停止することができます。
        </p>
        <p>
          <strong>４項</strong>
          アニメファンドは、本条に基づきアニメファンドが行った行為により会員に生じた損害について一切の責任を負いません。
        </p>
      </section>
      <section>
        <h4>第２０条（反社会的勢力等の排除）</h4>
        <p>
          <strong>１項</strong>
          ユーザーは、暴力団、暴力団員および暴力団員でなくなったときから５年を経過しない者、暴力団準構成員、暴力団関係企業に属する者、総会屋等、社会運動等標ぼうゴロ、特殊知能暴力集団等、テロリスト等、日本政府または外国政府が経済制裁の対象として指定する者（以下上記の９者を総称して「暴力団員等」といいます。）、暴力団員等の共生者、その他これらに準ずる者（以下、上記のすべてを総称して「反社会的勢力等」といいます。）のいずれかにも該当しないこと、かつ将来にわたっても該当しないこと、および自らまたは第三者を利用して、暴力的な要求行為、法的な責任を超えた不当な要求行為、取引に関して、脅迫的な言動をし、または暴力を用いる行為、風説を流布し、偽計を用いまたは威力を用いてアニメファンドの信用を毀損し、またはアニメファンドの業務を妨害する行為、その他これらに準ずる行為（以下総称して「不当な要求行為など」といいます。）を行わないことを確約することとします。
        </p>
        <p>
          <strong>２項</strong>
          前項に定める「暴力団員等の共生者」とは、以下のいずれかに該当するものをいいます。
        </p>
        <ul>
          <li>（１）暴力団員等が、経営を支配していると認められる関係を有する者</li>
          <li>（２）暴力団員等が、経営に実質的に関与していると認められる関係を有する者</li>
          <li>
            （３）自己もしくは第三者の不正の利益を図る目的、または第三者に損害を加える目的をもってするなど、不当に暴力団員等を利用していると認められる関係を有する者
          </li>
          <li>（４）暴力団員等に対して資金等を提供し、または便宜を供与するなどの関与をしていると認められる関係を有する者</li>
          <li>（５）暴力団員等と社会的に非難されるべき関係を有する者</li>
          <li>
            （６）その他暴力団員等の資金獲得活動に乗じ、または暴力団員等の威力、情報力、資金力等を利用することによって自ら利益拡大を図る者
          </li>
        </ul>
        <p>
          <strong>３項</strong>
          ユーザーが１項の確約事項に違反する場合、アニメファンドは、当該ユーザーに対して、直ちに本サービスの提供を停止するものとします。この場合、ユーザーに損害等が生じた場合でも、当該損害等について、アニメファンドおよび決済代行事業者、提携カード会社その他の第三者に一切の賠償請求をすることはできません。
        </p>
      </section>
      <section>
        <h4>第２１条（禁止行為）</h4>
        <p>
          <strong>１項</strong>
          ユーザーは、本サービスの利用にあたって、以下各号のいずれかに該当する行為、あるいはそのおそれがある行為を行ってはならないものとします。
        </p>
        <ul>
          <li>（１）本サービスを不正の目的をもって利用する行為</li>
          <li>（２）アニメファンド、他のユーザー、その他の第三者の知的財産権、肖像権、パブリシティ権その他の権利を侵害する行為</li>
          <li>（３）アニメファンド、他のユーザー、その他の第三者の名誉もしくは信用を毀損し、またはプライバシーを侵害する行為</li>
          <li>（４）詐欺等の犯罪に結びつく行為</li>
          <li>（５）コンピュータウイルスなど有害なプログラム等を送信もしくは提供する行為、または推奨する行為</li>
          <li>（６）アニメファンド、他のユーザー、その他の第三者の情報を改ざん、消去する行為</li>
          <li>（７）アニメファンド、他のユーザー、その他の第三者の設備を不正に利用し、またはその運営に支障を与える行為</li>
          <li>（８）法令、本規約または公序良俗に違反する行為</li>
          <li>（９）本サービスの運営を妨害する行為</li>
          <li>（１０）本サービスにおけるメッセージ機能を、本サービス以外の目的に使用する行為</li>
          <li>（１１）その他アニメファンドが不適当と判断する行為</li>
        </ul>
        <p>
          <strong>２項</strong>
          ユーザーが前項各号のいずれかに該当する行為を行ったことにより、アニメファンドが何らかの損害を被った場合、アニメファンドは当該ユーザーに対して損害賠償の請求ができるものとします。
        </p>
      </section>
      <section>
        <h4>第２２条（個人情報の取扱い）</h4>
        <p>
          <strong>１項</strong>
          アニメファンドは、ユーザーから提供された個人情報を本サービスの提供に必要な範囲およびアニメファンドプライバシーポリシーで定められた目的の範囲で使用することができるものとし、ユーザーは、このプライバシーポリシーに従ってアニメファンドがユーザーから提供された個人情報を取扱うことについて同意します。
        </p>
        <p>
          <strong>２項</strong>
          応援者は、本サービス上で応援契約が成立した場合、プロジェクトオーナーに対して、リターンの提供を利用目的として、応援者の氏名、住所、応援額、選択したリターンの内容、プロジェクトオーナー宛のメッセージ、その他、リターンの履行に必要な情報を提供することに同意するものとします。
        </p>
        <p>
          <strong>３項</strong>
          アニメファンドは、プロジェクトオーナーによるリターンの不履行に備えて保険に加入することがあり、当該保険金の請求手続きを目的として手続きに必要な範囲で、ユーザーの氏名、住所、プロジェクト内容、応援内容等の必要な情報を提供する場合があり、ユーザーはこの情報提供について同意するものとします。
        </p>
      </section>
      <section>
        <h4>第２３条（機密保持）</h4>
        <p>
          <strong>１項</strong>
          本規約において「秘密情報」とは、利用規約または本サービスに関連して、ユーザーが、アニメファンドより書面、口頭若しくは記録媒体等により提供若しくは開示されたか、または知り得た、アニメファンドの技術、営業、業務、財務、組織、その他の事項に関する全ての情報を意味します。ただし、（１）アニメファンドから提供若しくは開示がなされたとき又または知得したときに、既に一般に公知となっていた、または既に知得していたもの、（２）アニメファンドから提供若しくは開示または知得した後、自己の責めに帰せざる事由により刊行物その他により公知となったもの、（３）提供または開示の権限のある第三者から秘密保持義務を負わされることなく適法に取得したもの、（４）秘密情報によることなく単独で開発したもの、（５）アニメファンドから秘密保持の必要なき旨書面で確認されたものについては、秘密情報から除外するものとします。
        </p>
        <p>
          <strong>２項</strong>
          ユーザーは、秘密情報を本サービスの利用の目的のみに利用するとともに事前の書面による承諾なしに第三者にアニメファンドの秘密情報を提供、開示または漏洩しないものとします。
        </p>
        <p>
          <strong>３項</strong>
          前項の定めに拘わらず、ユーザーは、法律、裁判所または政府機関の命令、要求または要請に基づき、法的根拠のある範囲内にて秘密情報を開示することができます。ただし、ユーザーは、当該命令、要求または要請があった場合、速やかにその旨をアニメファンドに通知しなければなりません。
        </p>
        <p>
          <strong>４項</strong>
          ユーザーは、秘密情報を記載した文書または磁気記録媒体等を複製する場合には、事前にアニメファンドの書面による承諾を得ることとし、複製物の管理については第２項に準じて厳重に行うものとします。
        </p>
        <p>
          <strong>５項</strong>
          ユーザーは、アニメファンドから求められた場合にはいつでも、遅滞なく、アニメファンドの指示に従い、秘密情報並びに秘密情報を記載または包含した書面その他の記録媒体物およびその全ての複製物を返却または廃棄しなければなりません。
        </p>
      </section>
      <section>
        <h4>第２４条（連絡／通知）</h4>
        <p>
          ユーザーは、本サービスに関する案内、システムメンテナンスに関する告知、その他アニメファンドからユーザーに対する連絡または通知は、Ｅメール等アニメファンドの定める方法で配信することを了承するものとします。アニメファンドからユーザーに対する連絡または通知は、ユーザーがアニメファンドに申請した連絡先に発信することにより、ユーザーに通常到達すべきときに到達したとみなされるものとします。
        </p>
      </section>
      <section>
        <h4>第２５条（本サービスの変更、追加または廃止）</h4>
        <p>
          <strong>１項</strong>
          アニメファンドは、いつでも本サービスの内容を変更、追加（以下、「変更等」という。）または廃止することができるものとします。本サービスの変更等がユーザーに重大な影響を及ぼす場合は、アニメファンドウェブサイトに当該変更等の内容を掲載してお知らせします。また、本サービスの廃止は、アニメファンド所定の方法により事前にユーザーに通知するものとします。
        </p>
        <p>
          <strong>２項</strong>
          アニメファンドは、本条に基づきアニメファンドが行った措置によりユーザーに生じた損害には一切責任を負いません。
        </p>
      </section>
      <section>
        <h4>第２６条（本サービスの停止）</h4>
        <p>
          アニメファンドは、次の各号のいずれかに該当する場合には、ユーザーに事前に通知することなく、本サービスの一部または全部を停止または中断することができるものとし、当該停止または中断によりユーザーに生じた損害には一切責任を負いません。
        </p>
        <ul>
          <li>（１）本サービスの提供のための装置、システムの保守または点検を行う場合</li>
          <li>（２）火災、停電、地震、天災、システム障害等により、本サービスの運営が困難な場合</li>
          <li>（３）外部ＳＮＳサービスに、トラブル、サービス提供の中断または停止、本サービスとの連携の停止、仕様変更等が生じた場合</li>
          <li>（４）その他、アニメファンドが停止または中断をやむをえないと判断した場合</li>
        </ul>
      </section>
      <section>
        <h4>第２７条（免責）</h4>
        <p>
          <strong>１項</strong>
          本サービスは、ユーザーが、プロジェクトオーナーまたは応援者として取引を行う場を提供するものであり、ユーザーに対して、プロジェクトが予定通り実行されることを保証するものではありません。
        </p>
        <p>
          <strong>２項</strong>
          本サービスに関連して、プロジェクトオーナーと応援者の間を含む、ユーザー同士の間で生じたトラブルに関しては、ユーザーの責任において処理および解決するものとし、アニメファンドはかかる事項について一切責任を負わないものとします。
        </p>
        <p>
          <strong>３項</strong>
          本サービスは、外部ＳＮＳサービスと連携することがありますが、かかる連携を保証するものではなく、本サービスにおいて外部ＳＮＳサービスと連携できなかった場合でも、アニメファンドは一切の責任を負いません。本サービスが外部ＳＮＳサービスと連携している場合において、ユーザーは外部ＳＮＳサービスの利用規約を自己の費用と責任で遵守するものとし、ユーザーと当該外部ＳＮＳサービスを運営する外部ＳＮＳ事業者との間で紛争等が生じた場合でも、ユーザーは当該紛争等について一切の責任を負いません。
        </p>
        <p>
          <strong>４項</strong>
          アニメファンドは、ユーザーが本サービスを利用する際に、コンピュータウイルスなど有害なプログラム等による損害を受けないことを保証しないものとします。
        </p>
        <p>
          <strong>５項</strong>
          アニメファンドは、ユーザーが本サービスを利用する際に使用するいかなる機器、ソフトウェアについても、その動作保証を一切しないものとします。
        </p>
        <p>
          <strong>６項</strong>
          アニメファンドは、ユーザーが本サービスを利用する際に発生する通信費用について、一切負担しないものとします。
        </p>
        <p>
          <strong>７項</strong>
          アニメファンドは、アニメファンドの故意、重過失がある場合を除き、ユーザーの逸失利益、間接損害、特別損害、拡大損害、弁護士費用等を賠償しないものとし、何らかの理由によりアニメファンドが責任を負う場合でも、アニメファンドはユーザーの損害につき、ユーザーがアニメファンドに本サービスの対価として支払った総額を限度額として、それ以上の賠償する責任を負わないものとします。
        </p>
        <p>
          <strong>８項</strong>
          本サービスの基準時間は、アニメファンドのサーバー、システムで管理する時間とし、実際の時間や本サービスで表示する時間とは一致しないもしくは動作しない場合があります。ユーザーはあらかじめこれを了解の上で本サービスを利用するものとします。
        </p>
        <p>
          <strong>９項</strong>
          ユーザーは、本サービスの利用に関連して課税が生じることがあることを認識して本サービスを利用するものとします。アニメファンドは、当該課税に関し一切関与しないものとし、課税の有無や課税額等については、ユーザー自らが、自らの責任で確認および対応するものとします。
        </p>
        <p>
          <strong>１０項</strong>
          アニメファンドは、応援者が各プロジェクトに対し記載した応援コメントについて、公序良俗に反する等の理由でサイト運営上好ましくないとアニメファンドが判断した場合は投稿者や当サイトでの予告なく削除できるものとします。
        </p>
      </section>
      <section>
        <h4>第２８条（権利帰属）</h4>
        <p>
          <strong>１項</strong>
          アニメファンドウェブサイトおよび本サービスに関する所有権および知的財産権は全てアニメファンドまたはアニメファンドにライセンスを許諾している者に帰属しており、本規約に定める登録に基づく本サービスの利用許諾は、アニメファンドウェブサイトまたは本サービスに関するアニメファンドまたはアニメファンドにライセンスを許諾している者の知的財産権の使用許諾を意味するものではありません。ユーザーは、いかなる理由によってもアニメファンドまたはアニメファンドにライセンスを許諾している者の知的財産権を侵害するおそれのある行為（逆アセンブル、逆コンパイル、リバースエンジニアリングを含みますが、これに限定されません。）をしないものとします。ただし、プロジェクトについてプロジェクトオーナーが提供した写真等の素材やプロジェクトの対象となる商品またはサービスについての権利は、プロジェクトオーナーまたはプロジェクトオーナーにライセンスを許諾している者に留保されるものとします。
        </p>
        <p>
          <strong>２項</strong>
          アニメファンドウェブサイトまたは本サービスにおいて、ユーザーが投稿その他送信を行った文章、画像、動画その他のデータ（前項但書に定めるものも含む）については、アニメファンドにおいて、無償で自由に利用（複製、複写、改変、第三者への再許諾その他のあらゆる利用を含みます。）することができるものとします。
        </p>
        <p>
          <strong>３項</strong>
          ユーザーは、プロジェクト内容について、アニメファンド、プロジェクトオーナーその他の第三者の名誉その他の権利ないし利益を侵害するものでない限り、アニメファンドの定めるプロジェクトのＵＲＬおよび埋め込みコード、プロジェクトタイトル、プロジェクト概要のテキストおよび画像、プロジェクトオーナーのプロフィールをインターネットおよび外部ＳＮＳサービス上で転載することができるものとします。また、これら以外の紙面媒体等への転載については、アニメファンドの承諾を得るものとします。
        </p>
      </section>
      <section>
        <h4>第２９条（本規約の変更）</h4>
        <p>
          アニメファンドは、本規約を変更することができるものとします。アニメファンドは、本規約を変更した場合には、アニメファンド所定の方法によりユーザーに当該変更内容を通知またはアニメファンドウェブサイトにて公表するものします。但し、法令上ユーザーの同意が必要となるような内容の変更の場合は、アニメファンド所定の方法によりユーザーの同意を得るものとします。
        </p>
      </section>
      <section>
        <h4>第３０条（地位の譲渡等）</h4>
        <p>
          <strong>１項</strong>
          ユーザーは、アニメファンドの書面による事前の承諾なく、利用規約上の地位または本規約に基づく権利若しくは義務につき、第三者に対し、譲渡、移転、担保設定、その他の処分をすることはできません。
        </p>
        <p>
          <strong>２項</strong>
          アニメファンドは本サービスにかかる事業を他社に譲渡した場合には、当該事業譲渡に伴い利用規約上の地位、本規約に基づく権利および義務並びにユーザーの登録情報その他の情報を当該事業譲渡の譲受人に譲渡することができるものとし、ユーザーは、かかる譲渡につき本項において予め同意したものとします。なお、本項に定める事業譲渡には、通常の事業譲渡のみならず、会社分割その他事業が移転するあらゆる場合を含むものとします。
        </p>
      </section>
      <section>
        <h4>第３１条（一部無効等）</h4>
        <p>
          <strong>１項</strong>
          本規約の一部の規定の全部または一部が法令に基づいて無効と判断された場合であっても、当該規定は元の意思にできる限り沿うように解釈されるものとし、当該規定の無効部分以外の部分および本規約のその他の規定は有効とします。
        </p>
        <p>
          <strong>２項</strong>
          本規約の規定の一部があるユーザーとの関係で無効とされ、または取り消された場合でも、本規約はその他のユーザーとの関係では有効とします。
        </p>
      </section>
      <section>
        <h4>第３２条（準拠法および合意管轄）</h4>
        <p>
          <strong>１項</strong>本規約の準拠法は日本法とします。
        </p>
        <p>
          <strong>２項</strong>
          本規約に関して紛争が生じた場合、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
        </p>
      </section>
    </>
  )
}
export default BaseTerms;
